<script lang="ts">
  import type { ApiField } from '../../data-tables-api';

  let {
    field: _field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();
</script>

<label class="inline-flex items-center gap-2">
  <input
    type="checkbox"
    checked={!!value}
    onchange={(e) => onChange((e.target as HTMLInputElement).checked)}
    {disabled}
    class="h-4 w-4 rounded border-[var(--color-border-3)]"
  />
  <span class="text-xs text-[var(--color-text-muted)]">{value ? 'так' : 'ні'}</span>
</label>
{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
